
export const programmes = {
  methods: {
    //查找无分页全部课程
    async getPublishList() {
      let res = await this.$http.get("/course/info/all/list");
      return res;
    },
    //查询课程计划列表
    async getCoursePlanList(obj) {
      let res = await this.$http.get("/course/study/plan/list",obj);
      return res.data;
    },
    //新增课程计划
    async addCoursePlan(obj) {
      let res = await this.$http.post("/course/study/plan", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //修改课程计划
    async upCoursePlan(obj) {
      let res = await this.$http.put("/course/study/plan", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //删除课程计划
    async delCoursePlan(id) {
      let res = await this.$http.delete(`/course/study/plan/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //获取培训指标
    async getTrainQuota(year) {
      let res = await this.$http.get("/course/quota",{
        year:year
      });
      return res.data;
    },
    //保存培训指标
    async saveTrainQuota(obj) {
      let res = await this.$http.post("/course/quota/setup", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
  },
};
